var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoUber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.601,
    height: 19.986,
    viewBox: "0 0 104.601 19.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.992)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.992)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.073)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.574,17.418a5.074,5.074,0,0,0,5.319-5.179V.2h3.255V19.693h-3.22v-1.82a8.3,8.3,0,0,1-5.739,2.135C3.57,20.043,0,17,0,12.379V.2H3.255V12.239a5.035,5.035,0,0,0,5.319,5.179ZM19.6,19.693h3.115V17.908a8.426,8.426,0,0,0,5.634,2.135c4.654,0,8.294-3.325,8.294-7.419,0-4.13-3.675-7.454-8.294-7.454a8.1,8.1,0,0,0-5.6,2.135V.2H19.6Zm8.5-2.135a5.2,5.2,0,0,1-5.459-4.934A5.194,5.194,0,0,1,28.1,7.689a5.184,5.184,0,0,1,5.424,4.934A5.207,5.207,0,0,1,28.1,17.558ZM46.02,5.2C41.4,5.2,37.9,8.564,37.9,12.589c0,4.235,3.675,7.419,8.4,7.419a8.67,8.67,0,0,0,6.824-3.045l-2.275-1.5a5.635,5.635,0,0,1-4.549,2.1,5.184,5.184,0,0,1-5.249-4.025H53.894v-.91c0-4.27-3.325-7.419-7.874-7.419Zm-4.9,6.054a4.868,4.868,0,0,1,4.829-3.6,4.8,4.8,0,0,1,4.794,3.6ZM63.623,8V5.379H62.538a4.364,4.364,0,0,0-3.78,1.855V5.484H55.644V19.693h3.115V11.609a3.427,3.427,0,0,1,3.535-3.64h1.33Z",
    transform: "translate(0 -0.2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.342)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.295,11.144H6.124a4.206,4.206,0,0,0,4.3-4.27A4.215,4.215,0,0,0,6.649,2.29c-1.75-.1-3.5-.035-5.214-.035-.035,0-.07.07-.14.1Zm0,1.26v8.574H0V1.1c.07-.035.1-.07.175-.07,2.17,0,4.34-.1,6.474.035a5.676,5.676,0,0,1,4.165,8.924A5.487,5.487,0,0,1,6.054,12.4c-1.365.035-2.73,0-4.095,0Z",
    transform: "translate(0 -0.992)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.12 5.913)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.879,7.134A5.792,5.792,0,1,0,1.295,7.1a5.82,5.82,0,0,0,5.774,5.949,5.885,5.885,0,0,0,5.809-5.914M0,7.1A6.977,6.977,0,0,1,7.1.1a6.984,6.984,0,0,1,7.034,7.1A7,7,0,0,1,7,14.168,7.035,7.035,0,0,1,0,7.1",
    transform: "translate(0 -0.099)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M46.514,19.026c-.245,0-.42.035-.595.035A3.606,3.606,0,0,0,42,22.316a6.4,6.4,0,0,0-.07,1.155v8.4H40.6V17.941h1.295v1.75a4.53,4.53,0,0,1,4.619-1.82Z",
    transform: "translate(-26.392 -11.919)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUber);
export default __webpack_public_path__ + "static/media/logo-uber.bc0f6970d303144632d808c80245fc14.svg";
export { ForwardRef as ReactComponent };